import createSession from 'helpers/createSession'
import generateUniqueId from 'helpers/generateUniqueId'
import getGeoData from 'helpers/getGeoData'
import I18n from 'i18n'
import {
    INITIALIZE_APP,
    SET_LANGUAGE,
    SET_USER_ID,
    SET_SESSION_DATA,
    TOGGLE_APP_STATE
} from '../constants/actionTypes'


export const initializeApp = () => async (dispatch, getState) => {
    const state = getState()
    const geoData = await getGeoData()

    dispatch({
        type: INITIALIZE_APP,
        userId: state.app.userId,
        session: state.app.session,
        clientIp: geoData.ip,
        countryCode: geoData.country && geoData.country.code && geoData.country.code.toUpperCase()
    })

}

export const setLanguage = language => dispatch => {
    I18n.setLocale(language)

    dispatch({
        type: SET_LANGUAGE,
        language
    })
}

export const setUserId = () => ({
    type: SET_USER_ID,
    userId: generateUniqueId()
})

export const setSessionData = () => (dispatch, getState) => {
    dispatch({
        type: SET_SESSION_DATA,
        session: createSession(getState().app.session)
    })
}

export const toggleAppState = isOpen => ({
    type: TOGGLE_APP_STATE,
    isOpen
})
